(function(angular) {
    window.app.controller('userOfficeController', ['$scope', '$http', '$compile', function ($scope, $http, $compile) {
    $scope.userInfoStatus = function (wrap){
        var sumInput = $(wrap + ' md-input-container').length - $(wrap + ' md-checkbox').length;
        var sumValidInput = $(wrap + ' .md-input-has-value:not(.md-input-invalid)').length;
        if($(wrap + ' md-checkbox').length > 0){
            sumInput = $(wrap + ' md-input-container').length - $(wrap + ' md-checkbox').length + 1;
            sumValidInput = $(wrap + ' .md-input-has-value:not(.md-input-invalid)').length;
            if($(wrap + ' .md-checked').length > 0){
                sumValidInput = $(wrap + ' .md-input-has-value:not(.md-input-invalid)').length + 1;
            }
        }
        var infoStatus = ((sumValidInput / sumInput) * 100).toFixed();
        return infoStatus + '%';
    };

    $scope.checkIfFromApplication = () => {
        if(localStorage.getItem("applicationFirstSent")) {
            $scope.setClick('.tab--user-offers');
            localStorage.removeItem("applicationFirstSent");
        } else {
            $scope.setClick('.tab--user-application');
        }
    }
    
    $scope.myDate = new Date();
        $scope.dateRange = {
            min: new Date(
                $scope.myDate.getFullYear() - 70,
                $scope.myDate.getMonth(),
                $scope.myDate.getDate()),
            max: new Date(
                $scope.myDate.getFullYear() - 18,
                $scope.myDate.getMonth(),
                $scope.myDate.getDate()),
        };

    $scope.person = {};
    $scope.userHasFreeReport = true;
    
    $scope.getUserPersonData = () => $scope.getFormData('personData');
    $scope.getUserContactData = () => $scope.getFormData('contactData');
    $scope.getUserInterestsData = () => $scope.getFormData('interestsData');
    
    $scope.setInputVal = function(formName){
        var inputs = $('[name="' + formName + '"] *[data-default-value]');
        inputs.each(function(){
            var name = $(this).attr('name');
            var defVal = $(this).attr('data-default-value');
            
            if(defVal === 'true') defVal = true;
            if(defVal === 'false') defVal = false;
            if(name == 'birthDate' && defVal) defVal=new Date(defVal);
            
            $scope.person[name] = defVal;
        })
        //console.log($scope.person);         
    }

    $scope.updateDefaultVal = function(formName){
        var inputs = $('[name="' + formName + '"] *[data-default-value]');
        
        inputs.each(function(){
            var tagName = $(this)[0].tagName;
            var newVal = $(this).val();
            if(tagName == 'MD-CHECKBOX') newVal = $(this).attr('aria-checked');
            if(tagName == 'MD-SELECT') newVal = $(this).siblings('select').children('option[selected]').val();
            if(tagName == 'MD-DATEPICKER') newVal = $scope.birdthDate();
            
            if(newVal) $(this).attr('data-default-value', newVal);      
        })
    }
    $scope.showResponseStatus = function(response){
        alert('dscd')
        if(response.status === 200) $scope.showAlert('success','Dane są zapisane');
        else $scope.showAlert('error','Wystąpił błąd podczas zapisywania danych')
    }
    $scope.updateUserProfile = function(formName){
        $scope.updateDefaultVal(formName)
        $scope.setInputVal(formName)

        if(formName === 'personData'){
            $scope.sendXHR({
                url: '/rest/office/user-info/personal',
                data: $scope.getUserPersonData,
                succesFunc: $scope.showResponseStatus
            })
        }
        if(formName === 'contactData'){
            $scope.sendXHR({
                url: '/rest/office/user-info/contacts',
                data: $scope.getUserContactData,
                succesFunc: $scope.showResponseStatus
            });
        }
        if(formName === 'interestsData'){
            $scope.sendXHR({
                url: '/rest/office/user-info/hobbies',
                data: $scope.getUserInterestsData,
                succesFunc: $scope.showResponseStatus
            });
        }
    }

      $scope.logout = function(){
          $scope.sendXHR({
            url: '/api/front/authorization/logout/logout',
            method: 'post',
            data: '',
            successFunc: $scope.reloadPage
          })
      }

      $scope.reloadPage = function () {
        location.reload();
      }

}]);


})(window.angular);



// WEBPACK FOOTER //
// src/js/controllers/userOfficeController.js